<template>
    <div class="lo">
        <div class="lo__modal">
            <ClipLoader :loading="true" color="#0774E7" />
            <p v-text="$ml.get(text)" />
        </div>
    </div>
</template>

<script>
    import ClipLoader from 'vue-spinner/src/ClipLoader';


    export default {
        components: {
          ClipLoader
        },

        props: {
            text: {
                type: String,
                required: true
            }
        }
    };
</script>

<style lang="scss" scoped>
    .lo {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(32, 31, 32, 0.6);
        display: flex;
        justify-content: center;
        align-items: center;

        &__modal {
            background: white;
            padding: 40px;
            border-radius: 12px;
            text-align: center;
            max-width: 328px;

            p {
                font-size: 16px;
                font-weight: 700;
                color: #2F363E;
                margin: 16px 0 0;
            }
        }
    }
</style>